/**
 * @module app.um
 */

abstract class AuthEvent { }
export class AuthReloadEvent extends AuthEvent { }  // Replaces auth:reloaded
export class AuthChangeEvent extends AuthEvent {    // Replaces auth:changed
    constructor(public authReloaded: boolean = false) {
        super();
        return Object.assign<AuthChangeEvent, AuthChangeEvent>(this, { authReloaded: authReloaded });
    }
}
export class AuthAutoDeterminationEvent extends AuthEvent { }
export class AuthCorrespondenceEvent extends AuthEvent { }
export class AuthExternalSystemChangeEvent extends AuthEvent { }
export class AuthExternalSystemErrorEvent extends AuthEvent { }
export class AuthIQCDocumentSkipEvent extends AuthEvent { }
export class AuthIQCMedicalReviewEvent extends AuthEvent { }
export class AuthIQCGuidelinesSearchEvent extends AuthEvent {
    constructor(public guidelines: any[]) {
        super();
        return Object.assign<AuthIQCGuidelinesSearchEvent, AuthIQCGuidelinesSearchEvent>(this, { guidelines: guidelines })
    }
}
export class AuthIQCGuidelinesSearchTimeoutEvent extends AuthEvent { }

abstract class AuthHeaderEvent { }
export class AuthHeaderChangeEvent extends AuthHeaderEvent { }  // Replaces auth-header:changed

abstract class AssignAuthsEvent { }
export class AssignAuthsReloadEvent extends AssignAuthsEvent { }

export interface IAuthCreatedEventDetail { authId: string }
export type AuthCreatedCustomEvent = CustomEvent<IAuthCreatedEventDetail>;

export interface IAuthChangeCustomEventDetail { authReloaded: boolean, triggerRules: boolean; }
export type AuthChangeCustomEvent = CustomEvent<IAuthChangeCustomEventDetail>;

export interface IAuthTriggerRulesEventDetail {
    triggerCorrespondenceRules?: boolean;
    triggerDeterminationRules?: boolean;
}
export type AuthTriggerRulesCustomEvent = CustomEvent<IAuthTriggerRulesEventDetail>;

abstract class ContactLogMethodEvent { }
export class ContactLogMethodReloadEvent extends ContactLogMethodEvent { }
abstract class ContactLogOutcomeEvent { }
export class ContactLogOutcomeReloadEvent extends ContactLogOutcomeEvent { }

abstract class ServiceFlagEvent { }
export class ServiceFlagReloadEvent extends ServiceFlagEvent { }

abstract class DiagnosisFlagEvent { }
export class DiagnosisFlagReloadEvent extends DiagnosisFlagEvent { }

abstract class AuthProviderReceivingEvent { }
export class AuthProviderReceivingReloadEvent extends AuthProviderReceivingEvent { }

abstract class AuthStatusEvent { }
export class AuthStatusReasonReloadEvent extends AuthStatusEvent { }
export class AuthStatusReloadEvent extends AuthStatusEvent { }

abstract class AuthServiceStatusEvent { }
export class AuthServiceStatusReasonReloadEvent extends AuthServiceStatusEvent { }
export class AuthServiceStatusReloadEvent extends AuthServiceStatusEvent { }

abstract class AuthMedicationEvent { }
export class AuthMedicationReloadEvent extends AuthMedicationEvent { }

abstract class AuthMedicationStatusEvent { }
export class AuthMedicationStatusReasonReloadEvent extends AuthMedicationStatusEvent { }
export class AuthMedicationStatusReloadEvent extends AuthMedicationStatusEvent { }

abstract class CareDayStatusEvent { }
export class CareDayStatusReasonReloadEvent extends CareDayStatusEvent { }

abstract class LevelOfCareEvent { }
export class LevelOfCareRevenueCodeMappingReloadEvent extends LevelOfCareEvent { }

abstract class ImportStatusAndHistoryEvent { }
export class ImportStatusAndHistoryReloadEvent extends ImportStatusAndHistoryEvent { }
